// update-ability.js
import ability from '@/config/ability.js'
import { alertToast } from '@/utilities/notification'
import { useAuthStore } from '@/stores/AuthStore'
import { useAccessStore } from '@/stores/AccessStore'
import { useCallCenterStore } from '@/stores/CallCenterStore'
import useApiRequest from '@/composables/useApiRequest'
import emitter from '@/utilities/eventBus.js'

export default async function updateAbility(routerInstance) {
  const authStore = useAuthStore()
  const accessStore = useAccessStore()
  const callCenterStore = useCallCenterStore()

  const getPermissions = async () => {
    try {
      const permissionsApiRequest = useApiRequest()

      const response = await permissionsApiRequest.send({
        endpoint: `/v1/users/${authStore.details.id}/permissions`,
        method: 'GET'
      })

      if (!response.success) {
        throw new Error('updateAbility() - Error fetching data')
      }

      const roles = response.data.roles
      const abilities = response.data.permissions
      const accessAllowed = response.data.access
      const callCenters = response.data.callCenters

      ability.update(abilities)

      if (accessAllowed === undefined || accessAllowed.regions.length === 0) {
        routerInstance.push({ path: '/no-access', replace: true })
        return Promise.reject('No access allowed')
      } else {
        authStore.updateRoles(roles)
        authStore.updateAccessAllowed(accessAllowed)

        // Set access allowed in AccessStore (this will auto-filter and persist accessSelected)
        accessStore.setAccessAllowed(accessAllowed)

        if (!accessStore.hasSelectedDealerships && authStore.details.userType !== 1) {
          // Emit event to open location selector modal
          // MainMenu will listen for this event and open the modal
          emitter.emit('open-location-selector-modal')
          // Still redirect to /access as fallback in case MainMenu is not mounted yet
          // The Access route can handle showing the modal or the page
          routerInstance.push({ path: '/access', replace: true })
        }
      }

      // Update user's call center permissions
      callCenterStore.updateCallCenters(callCenters)

      return Promise.resolve()
    } catch (err) {
      console.error('ERROR:', err)
      alertToast('Permissions error', err.message, 'error')
      return Promise.reject(err)
    }
  }

  return getPermissions()
}
